export enum FieldName {
  Email = 'email address',
  FirstName = 'first name',
  LastName = 'last name'
}

export const spinnerStockNumber = 9911811097;

export const shareData = {
  title: 'Red Bull Rampage Giveaway',
  text: 'Enter to win a custom-built mountain bike and a trip to Red Bull Rampage'
};
